import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from "./home/home.component";
import {PagesComponent} from "./pages.component";
import {AuthGuard} from "../core/guards/auth-guard";
import {HubGuard} from "../core/guards/hub-guard";
import {RoleEnum} from "../shared/enums/role.enum";
import {UserTypeEnum} from "../shared/enums/user-type.enum";

const routes: Routes = [
  {
    path: '',
    component: PagesComponent,
    children: [
      { path: '', redirectTo: 'app-select', pathMatch: 'full' },
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: 'contract-select',
        loadChildren: () => import('./contract-select/contract-select.module').then(m => m.ContractSelectModule)
      },
      {
        path: 'app-select',
        //canActivate: [() => HubGuard()],
        loadChildren: () => import('./multi-apps/multi-apps-routing.module').then(m => m.MultiAppsRoutingModule)
      },
      {
        path: 'real-time',
        canActivate: [() => AuthGuard([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.TEMPO_REAL, RoleEnum.TEMPO_REAL_MAP])],
        loadChildren: () => import('./real-time/real-time.module').then(m => m.RealTimeModule)
      },
      {
        path: 'alert',
        canActivate: [() => AuthGuard([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.EQUIPMENT_ALERT])],
        loadChildren: () => import('./pbt-configuration/pbt-configuration.module').then(m => m.PbtConfigurationModule)
      },
      {
        path: 'status-monitoring',
        canActivate: [() => AuthGuard([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.STATUS_EQUIPAMENTOS, RoleEnum.INVID])],
        loadChildren: () => import('./status-monitoring/status-monitoring.module').then(m => m.StatusMonitoringModule)
      },
      {
        path: 'monitoring',
        canActivate: [() => AuthGuard([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.OCORRENCIA, RoleEnum.MOTIVO_OCORRENCIA, RoleEnum.EQUIPMENT_VIDEO])],
        loadChildren: () => import('./monitoring/monitoring.module').then(m => m.MonitoringModule)
      },
      {
        path: 'sync-diff',
        canActivate: [() => AuthGuard([], true, [UserTypeEnum.ADMIN, UserTypeEnum.SUS])],
        loadChildren: () => import('./sync-diff/sync-diff.module').then(m => m.SyncDiffModule)
      },
      {
        path: 'triagem',
        canActivate: [() => AuthGuard([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.PROCESSAMENTO_TRIAGEM])],
        loadChildren: () => import('./triagem/triagem.module').then(m => m.TriagemModule)
      },
      // {
      //   path: 'triagem-passagem',
      //   canActivate: [() => AuthGuard([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.PROCESSAMENTO_TRIAGEM])],
      //   loadChildren: () => import('./triagem-passagem/triagem-passagem.module').then(m => m.TriagemPassagemModule)
      // },
      {
        path: 'exportacao',
        canActivate: [() => AuthGuard([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.PROCESSAMENTO_TRIAGEM])],
        loadChildren: () => import('./exportacao/exportacao.module').then(m => m.ExportacaoModule)
      },
      {
        path: 'change-password',
        loadChildren: () => import('./change-password/change-password.module').then(m => m.ChangePasswordModule)
      },
      {
        path: 'dashboard',
        canActivate: [() => AuthGuard([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.TEMPO_REAL])],
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'configuracao-equipamento',
        canActivate: [() => AuthGuard([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR])],
        loadChildren: () => import('./configuracao-equipamento/configuracao-equipamento.module').then(m => m.ConfiguracaoEquipamentoModule)
      },
      {
        path: 'general-config',
        canActivate: [() => AuthGuard([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR])],
        loadChildren: () => import('./general-config/general-config.module').then(m => m.GeneralConfigModule)
      },
      {
        path: 'tracker-vs',
        canActivate: [() => AuthGuard([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.TRACKER_VS, RoleEnum.TRACKER_VS_GENERAL, RoleEnum.TRACKER_VS_INTERVAL, RoleEnum.TRACKER_VS_ANALYSIS])],
        loadChildren: () => import('./tracker-vs/tracker-vs.module').then(m => m.TrackerVSModule)
      },
      {
        path: 'iframe-falcon',
        //canActivate: [() => AuthGuard([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.TRACKER_VS, RoleEnum.TRACKER_VS_GENERAL, RoleEnum.TRACKER_VS_INTERVAL, RoleEnum.TRACKER_VS_ANALYSIS])],
        loadChildren: () => import('./iframe-falcon/iframe-falcon.module').then(m => m.IframeFalconModule)
      },
      {
        path: 'iframe-iot-manager',
        //canActivate: [() => AuthGuard([RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.TRACKER_VS, RoleEnum.TRACKER_VS_GENERAL, RoleEnum.TRACKER_VS_INTERVAL, RoleEnum.TRACKER_VS_ANALYSIS])],
        loadChildren: () => import('./iframe-iot-manager/iframe-iot-manager.module').then(m => m.IframeIotManagerModule)
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
